<template>
  <div id="opiniones" class="testimonials-section">
    <div class="container">
      <div class="title-column">
        <div class="testimonial-header">
          <div class="label">Opiniones Reales</div>
          <h2>¿Qué dicen nuestros clientes?</h2>
          <p>Revisa qué han dicho nuestros clientes por su experiencia.</p>
          <div class="arrows">
            <button @click="moveToPrevSlide" class="arrow-btn" aria-label="Previous testimonial">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>
            <button @click="moveToNextSlide" class="arrow-btn" aria-label="Next testimonial">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <div class="carousel-column">
        <div class="testimonial-carousel">
          <transition name="fade" mode="out-in">
            <div :key="currentSlide" class="testimonial-slide">
              <blockquote class="testimonial-quote">"{{ testimonials[currentSlide].quote }}"</blockquote>
              <div class="author-info">
                <p class="author">{{ testimonials[currentSlide].author }}</p>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="logos-section">
      <div class="logos-container">
        <!-- Row 1: 8 logos -->
        <div class="logos-row">
          <div class="logo-wrapper"><img src="@/assets/cg/logos/im.png" alt="IntegraMédica" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/regonesi.png" alt="Regonesi" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/uc-logo.svg" alt="UC Christus" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/davila-logo.svg" alt="Dávila" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/bionet-logo.svg" alt="BioNet" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/reley.png" alt="Reley" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/lb-logo.png" alt="Blanco" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/cardiopro.png" alt="CardioPro" class="logo" /></div>
        </div>
        <!-- Row 2: 2 logos centered -->
        <div class="logos-row mt-4">
          <div class="logo-wrapper"><img src="@/assets/cg/logos/smd-logo.png" alt="Sports" class="logo" /></div>
          <div class="logo-wrapper"><img src="@/assets/cg/logos/mainque.png" alt="Mainque" class="logo" /></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Testimonials',
  data() {
    return {
      currentSlide: 0,
      autoPlayInterval: null,
      testimonials: [
        {
          quote: "Con Clinic Go automatizamos el proceso manual de agendar visitas a domicilio, lo cual nos trajo como beneficio optimizar nuestros recursos y mejorar la experiencia de nuestros usuarios, fidelizándolos con nuestra marca como prestador de salud visual.",
          author: "Karin Saez - Reley",
          initials: "KS"
        },
        {
          quote: "Andinno es una startup de base tecnológica con aplicación bioclínica, y Clinic Go nos ha permitido ofrecer nuestro innovador servicio de manera rápida y con una eficiente y grata experiencia para nuestros usuarios. También nos genera eficiencia y ahorros al poder automatizar el servicio y contar con un modelo que integra tecnología, personal en terreno y traslado de muestras a nuestro laboratorio.",
          author: "Paula Egaña, CFO",
          initials: "PE"
        }
      ]
    }
  },
  methods: {
    moveToNextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.testimonials.length
    },
    moveToPrevSlide() {
      this.currentSlide = this.currentSlide === 0 
        ? this.testimonials.length - 1 
        : this.currentSlide - 1
    }
  }
}
</script>

<style scoped>
.testimonials-section {
  background: #f7fbfe;
  padding: 20px 0 0; 
}

.container {
  display: flex;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px 20px;
  align-items: center;
}

.title-column {
  flex: 0 0 25%;
}

.label {
  display: inline-block;
  background: #e0f2fe;
  color: #3b82f6; 
  padding: 4px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 24px;
}

.testimonial-header h2 {
  font-size: 24px;
  color: #1e293b;
  margin: 0 0 8px 0;
  font-weight: 700;
  line-height: 1.2;
}

.testimonial-header p {
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
  margin: 0 0 16px 0;
}

.arrows {
  display: flex;
  gap: 32px;
  justify-content: center;
  margin-top: 20px;
}

.arrow-btn {
  background: none;
  border: none;
  color: #1e293b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  padding: 6px;
}

.arrow-btn:hover {
  color: #0ea5e9;
  transform: scale(1.2);
}

.carousel-column {
  flex: 1;
  background: #ffffff;
  padding: 16px 32px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.02);
}

.testimonial-carousel {
  position: relative;
  min-height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.testimonial-slide {
  width: 100%;
  text-align: center;
}

.testimonial-quote {
  font-size: 16px;
  line-height: 1.4;
  color: #334155;
  margin: 0 0 12px 0;
  font-style: normal;
  font-weight: 500;
  min-height: 60px; /* Ultra-slim quote area */
}

.author-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.author {
  font-weight: 700;
  color: #1e293b;
  font-size: 15px;
  margin: 0;
}

/* Fade transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Static logos grid */
.logos-section {
  border-top: 1px solid #e2e8f0;
  padding: 40px 0 60px;
  background: #f7fbfe; /* Unified with testimonials background */
}

.logos-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.logos-row {
  display: flex;
  flex-wrap: nowrap; /* Avoid wrapping for the main row if possible */
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.mt-4 {
  margin-top: 1.2rem;
}

.logo-wrapper {
  width: 140px; 
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1; /* Allow slight shrinking on smaller screens */
  padding: 2px;
}

.logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: grayscale(100%) opacity(0.5);
  transition: all 0.4s ease;
}

.logo:hover {
  filter: grayscale(0%) opacity(1);
  transform: scale(1.1);
}

@media (max-width: 900px) {
  .testimonials-section {
    padding: 60px 0 0;
  }

  .container {
    flex-direction: column;
    gap: 40px;
    padding: 0 24px 60px;
  }

  .title-column {
    flex: none;
    width: 100%;
    text-align: center;
  }

  .testimonial-header h2 {
    font-size: 32px;
  }

  .arrows {
    justify-content: center;
  }

  .carousel-column {
    width: 300px;
    height: 30px;
  }

  .testimonial-slide {
    padding: 32px 24px;
  }

  blockquote {
    font-size: 16px;
  }

  .logos-set {
    gap: 60px;
  }

  .logo {
    height: 40px;
  }
}

@media (max-width: 500px) {
  .testimonial-header h2 {
    font-size: 28px;
  }

  .testimonial-slide {
    padding: 24px 20px;
    width: 90%;
  }

  .logos-set {
    gap: 10px;
    padding: 0 20px;
  }

  .logo {
    height: 100px;
  }
}
</style>